import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { AppStateProvider } from "./lib/mockState";
import { ControlCenterRoutes } from "./routes/control/ControlCenterRoutes";
import "./index.css";

const LoginPage = lazy(() => import("./routes/(auth)/login/page").then((module) => ({ default: module.LoginPage })));

const RouteFallback = () => (
  <div className="min-h-screen grid place-items-center bg-slate-950 text-xs font-bold uppercase tracking-widest text-slate-400">
    Loading Control Center...
  </div>
);

function ControlApp() {
  return (
    <AuthProvider>
      <AppStateProvider>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/control/*" element={<ControlCenterRoutes />} />
            <Route path="/" element={<Navigate to="/control/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/control/dashboard" replace />} />
          </Routes>
        </Suspense>
      </AppStateProvider>
    </AuthProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <ControlApp />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
